export default IconHdr => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hdr" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3 16v-8" />
  <path d="M7 8v8" />
  <path d="M3 12h4" />
  <path d="M10 8v8h2a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2h-2z" />
  <path d="M17 12h2a2 2 0 1 0 0 -4h-2v8m4 0l-3 -4" />
</svg>`;